import { CurriculumTemplateResponse } from "../contracts/CurriculumTemplateResponse";
import { EnrolmentResponse } from "../contracts/EnrolmentResponse";
import { ProgrammeResponse } from "../contracts/ProgrammeResponse";
import { ProgrammeSummaryResponse } from "../contracts/ProgrammeSummaryResponse";
import { TopicResponse } from "../contracts/TopicResponse";
import { Enrolment } from "../models/Enrolment";
import { EnrolResult } from "../models/EnrolResult";
import { CurriculumTemplate, Programme, ProgrammeSummary, Topic } from "../models/Programme";

export const mapResponseToCurriculumTemplate = (resp: CurriculumTemplateResponse): CurriculumTemplate => ({
  code: resp.code,
  licenceClass: resp.licenceClass,
  templateVersion: resp.templateVersion,
  source: resp.source,
  theoryTopicCount: resp.theoryTopicCount,
  practicalTopicCount: resp.practicalTopicCount,
});

export const mapResponseToTopic = (resp: TopicResponse): Topic => ({
  id: resp.id,
  code: resp.code,
  title: resp.title,
  kind: resp.kind,
  unitMinutes: resp.unitMinutes,
  requiredCount: resp.requiredCount,
  sortOrder: resp.sortOrder,
  isArchived: resp.isArchived,
});

export const mapResponseToProgrammeSummary = (resp: ProgrammeSummaryResponse): ProgrammeSummary => ({
  id: resp.id,
  name: resp.name,
  licenceClass: resp.licenceClass ?? null,
  isLicenceClassProgramme: resp.isLicenceClassProgramme === true,
  templateCode: resp.templateCode ?? null,
  templateVersion: resp.templateVersion ?? null,
  isArchived: resp.isArchived,
  enrolledCount: resp.enrolledCount,
});

export const mapResponseToProgramme = (resp: ProgrammeResponse): Programme => ({
  id: resp.id,
  name: resp.name,
  licenceClass: resp.licenceClass ?? null,
  isLicenceClassProgramme: resp.isLicenceClassProgramme === true,
  templateCode: resp.templateCode ?? null,
  templateVersion: resp.templateVersion ?? null,
  isArchived: resp.isArchived,
  topics: (resp.topics ?? []).map(mapResponseToTopic),
});

export const mapResponseToEnrolment = (resp: EnrolmentResponse): Enrolment => ({
  id: resp.id,
  memberId: resp.memberId,
  programmeId: resp.programmeId,
  programmeName: resp.programmeName,
  licenceClass: resp.licenceClass ?? null,
  isLicenceClassProgramme: resp.isLicenceClassProgramme === true,
  enrolledOn: resp.enrolledOn,
  completedOn: resp.completedOn ?? null,
  isCompleted: resp.completedOn != null,
  signedOn: resp.signedOn ?? null,
  isSigned: resp.signedOn != null,
});

export const mapResponseToEnrolResult = (resp: EnrolmentResponse): EnrolResult => ({
  enrolment: mapResponseToEnrolment(resp),
  perVisitContract: resp.perVisitContract ?? "notRequested",
});
